<script>
export default {
  name: 'DatabaseTotals',
  props: {
    client_id: Number,
  },
  async mounted() {
    await this.getDashboardData(this.client_id);
  },
  data() {
    return {
      database_data_loading: true,
      database_data: {},
    }
  },
  watch: {
    client_id: {
      handler(newVal) {
        this.getDashboardData(newVal);
      }
    }
  },
  methods: {
    async getDashboardData(client_id) {
      this.database_data_loading = true;
      try {
        const response = await fetch(import.meta.env.VITE_API_BASEURL + 'api/dashboard/' + client_id + '/database', {
          credentials: 'include'
        });

        this.database_data = await response.json();
      } catch (error) {
        console.error(error);
      } finally {
        this.database_data_loading = false;
      }
    }
  }
}
</script>

<template>
  <v-container v-if="!database_data_loading">
    <v-row>
      <v-col v-if="database_data.total_poles">
        Aantal masten: {{ database_data.total_poles }}
      </v-col>
    </v-row>
    <v-row>
      <v-col v-if="database_data.total_fixtures">
        Aantal armaturen: {{ database_data.total_fixtures }}
      </v-col>
    </v-row>
    <v-row>
      <v-col v-if="database_data.total_lamps">
        Aantal lampen: {{ database_data.total_lamps }}
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped lang="scss">

</style>
